export default {
    title: 'underline',
    action: [ 'underline' ],
    description: 'Underline',
    icon: 'Underline',
};
